import React from "react";
import styled from "styled-components";
import ItineraryCard from "./itinerary-card";
import ReactCSSTransitionGroup from "react-addons-css-transition-group";
import Img from "gatsby-image";

const StyledColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  flex: 1 0 232px;
`;

const ColumnHeader = styled.div`
  font-family: "Oswald";
  text-transform: uppercase;
  font-weight: 400;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const ColumnHeaderActivity = styled.h3`
  font-size: 16px;
  margin-bottom: 8px;
`;
const ColumnHeaderDay = styled.h4`
  font-size: 12px;
  background-color: #d43826;
  color: white;
  border-radius: 4px;
  padding: 5px 7px;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
`;
const ColumnHeaderHR = styled.hr`
  width: 100%;
  margin-bottom: 0;
  border: 2px solid #d43826;
`;

const ColumnHeaderDayHRWrapper = styled.div`
  width: 100%;
  position: relative;
  height: 24px;
  display: flex;
  align-items: center;
  margin-bottom: 15px;
`;
const ColumnContentWrapper = styled.div`
  display: flex;
  flex-direction: row;
`;

const ItemsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  overflow-y: scroll;
  overflow-x: hidden;
  height: 700px;
`;

const ExpanseContent = styled.div`
  width: 500px;
  padding: 15px 25px;

  h3 {
    margin-bottom: 10px;
    font-size: 18px;
  }

  p {
    font-size: 14px;
    line-height: 20px;
  }
`;

const TheExpanse = styled.div`
  display: flex;
  flex-direction: column;
  width: 500px;
  overflow: hidden;

  &.column-enter {
    width: 0;
  }

  &.column-enter-active {
    width: 500px;
    transition: width 500ms ease-out;
  }

  &.column-leave.column-leave-active {
    width: 0px;
    transition: width 500ms ease-in;
  }

  h3,
  h4 {
    font-weight: bold;
    margin-bottom: 5px;
  }
  p {
    margin-bottom: 5px;
  }

  strong {
    font-weight: bold;
  }
`;
const StyledImg = styled(Img)`
  margin-bottom: 10px;
`;

const Column = ({
  activities,
  columnTitle,
  columnDay,
  images,
  expanded,
  setExpanded
}) => {
  function handleExpand(activity) {
    if (expanded.activity && expanded.activity.id === activity.id) {
      setExpanded({
        day: null,
        activity: null
      });
    } else {
      setExpanded({
        day: columnDay,
        activity
      });
    }
  }

  const isExpanded = expanded && expanded.day === columnDay;
  return (
    <StyledColumn>
      <ColumnHeader>
        <ColumnHeaderActivity>{columnTitle}</ColumnHeaderActivity>
        <ColumnHeaderDayHRWrapper>
          <ColumnHeaderHR />
          <ColumnHeaderDay>{columnDay}</ColumnHeaderDay>
        </ColumnHeaderDayHRWrapper>
      </ColumnHeader>
      <ColumnContentWrapper>
        <ItemsWrapper>
          {activities.map(activity => (
            <ItineraryCard
              key={activity.id}
              activity={activity}
              image={images.thumbnails[activity.imageName]}
              canExpand={!!(activity && activity.notes)}
              isExpanded={
                expanded.activity && expanded.activity.id === activity.id
              }
              setExpanded={handleExpand}
            />
          ))}
        </ItemsWrapper>
        <ReactCSSTransitionGroup
          transitionName="column"
          transitionEnterTimeout={500}
          transitionLeaveTimeout={500}
        >
          {isExpanded && expanded.activity && (
            <TheExpanse>
              <ExpanseContent>
                <h3>{expanded.activity.label}</h3>
                {expanded.activity.imageName && (
                  <StyledImg
                    fixed={images.details[expanded.activity.imageName]}
                  />
                )}
                <p
                  dangerouslySetInnerHTML={{
                    __html: expanded.activity.notes
                  }}
                />
              </ExpanseContent>
            </TheExpanse>
          )}
        </ReactCSSTransitionGroup>
      </ColumnContentWrapper>
    </StyledColumn>
  );
};

export default Column;
